const wifiNetWorkImage = require("../assets/wifi networkImage.jpeg");
const doorLockVideo = require("../assets/doorLockVideo.mp4");

module.exports = {
  // BaseURL: "http://localhost:8080/api/v1/bookings",
  BaseURL: "https://backend.cinnamonlakehouse.it/api/v1/bookings",
  // ImageBaseURL: "http://localhost:8080/api/v1/bookings/images/",
  ImageBaseURLServer: "https://evotec.software:4343/Test/CinnamonLakeHouse/",
  RecepitURLServer:
    "https://evotec.software:4343/Test/CinnamonLakeHouse/Recipt/",
  FrontEndURL: "https://booking.cinnamonlakehouse.it/",
  // FrontEndURL: "http://localhost:3000/BookingConfirmation/",

  genderOptions: [
    { label: "Male", value: "MALE" },
    { label: "Female", value: "FEMALE" },
    // { label: "Other", value: "OTHER" },
  ],
  gender: {
    male: "MALE",
    female: "FEMALE",
    other: "OTHER",
  },

  status: {
    pending: "PENDING",
    confirm: "CONFIRM",
    processing: "PROCESSING",
    done: "DONE",
  },

  role: {
    admin: "ADMIN",
  },

  guestType: [
    { ID: 16, name: "OSPITE SINGOLO" },
    { ID: 17, name: "CAPO FAMIGLIA" },
    { ID: 18, name: "CAPO GRUPPO" },
    { ID: 19, name: "FAMILIARE" },
    { ID: 20, name: "MEMBRO GRUPPO" },
  ],

  docType: [
    { ID: "IDENT", name: "CARTA DI IDENTITA'" },
    { ID: "CIDIP", name: "CARTA ID. DIPLOMATICA" },
    { ID: "IDELE", name: "CARTA IDENTITA' ELETTRONICA" },
    { ID: "CERID", name: "CERTIFICATO D'IDENTITA'" },
    { ID: "PASSE", name: "PASSAPORTO DI SERVIZIO" },
    { ID: "PASDI", name: "PASSAPORTO DIPLOMATICO" },
    { ID: "PASOR", name: "PASSAPORTO ORDINARIO" },
    { ID: "PATEN", name: "PATENTE DI GUIDA" },
    { ID: "PATNA", name: "PATENTE NAUTICA" },
    { ID: "PORM5", name: "PORTO D'ARMI GUARDIE GIUR" },
    { ID: "PORM3", name: "PORTO D'ARMI USO SPORTIVO" },
    { ID: "PORM2", name: "PORTO FUCILE DIF. PERSON." },
    { ID: "PORM1", name: "PORTO FUCILE USO CACCIA" },
    { ID: "PORM4", name: "PORTO PISTOLA DIF. PERSON" },
    { ID: "TENAV", name: "TES. ENTE NAZ. ASSIS.VOLO" },
    { ID: "TFEXD", name: "TES. FERROV. EX DEPUTATI" },
    { ID: "TFERD", name: "TES. FERROVIARIA DEPUTATI" },
    { ID: "TESPT", name: "TES. POSTE E TELECOMUNIC." },
    { ID: "TECAM", name: "TES. UNICO PER LA CAMERA" },
    { ID: "TEDOG", name: "TES.DOGANALE RIL.MIN.FIN." },
    { ID: "CFMIL", name: "TESS. AG. E AG.SC. C.F.S." },
    { ID: "PPAGE", name: "TESS. AGENTI/ASS.TI P.P." },
    { ID: "PSAPP", name: "TESS. AGENTI/ASS.TI P.S." },
    { ID: "ACMIL", name: "TESS. APP.TO AG.CUSTODIA" },
    { ID: "CCMIL", name: "TESS. APP.TO CARABINIERI" },
    { ID: "GFMIL", name: "TESS. APP.TO FINANZIERE" },
    { ID: "VIMIL", name: "TESS. APP.TO/VIG. URBANO" },
    { ID: "VVMIL", name: "TESS. APP.TO/VIG. VV.FF." },
    { ID: "TESCS", name: "TESS. CONSIGLIO DI STATO" },
    { ID: "TESCA", name: "TESS. CORTE D'APPELLO" },
    { ID: "TECOC", name: "TESS. CORTE DEI CONTI" },
    { ID: "TEFSE", name: "TESS. FERROV. SENATO" },
    { ID: "PSFUN", name: "TESS. FUNZIONARI P.S." },
    { ID: "TETEL", name: "TESS. IDENTIF.TELECOM IT." },
    { ID: "TEAMC", name: "TESS. ISCR. ALBO MED/CHI." },
    { ID: "TEAOD", name: "TESS. ISCRIZ. ALBO ODONT." },
    { ID: "PPISP", name: "TESS. ISPETTORI P.P." },
    { ID: "PSISP", name: "TESS. ISPETTORI P.S." },
    { ID: "TESEA", name: "TESS. MEMBRO EQUIP. AEREO" },
    { ID: "MMMIL", name: "TESS. MILIT. M.M." },
    { ID: "SDMIL", name: "TESS. MILIT. TRUPPA SISMI" },
    { ID: "EIMIL", name: "TESS. MILITARE E.I." },
    { ID: "TENAT", name: "TESS. MILITARE NATO" },
    { ID: "AMMIL", name: "TESS. MILITARE TRUPPA A.M" },
    { ID: "TESAE", name: "TESS. MIN. AFFARI ESTERI" },
    { ID: "TESMB", name: "TESS. MIN.BEN.E ATT.CULT." },
    { ID: "TEMPI", name: "TESS. MIN.PUBB.ISTRUZIONE" },
    { ID: "TESMN", name: "TESS. MINIST. TRASP/NAVIG" },
    { ID: "TESMD", name: "TESS. MINISTERO DIFESA" },
    { ID: "TESMF", name: "TESS. MINISTERO FINANZE" },
    { ID: "TESMG", name: "TESS. MINISTERO GIUSTIZIA" },
    { ID: "TESMI", name: "TESS. MINISTERO INTERNO" },
    { ID: "TESLP", name: "TESS. MINISTERO LAVORI PU" },
    { ID: "TESMS", name: "TESS. MINISTERO SANITA'" },
    { ID: "TESMT", name: "TESS. MINISTERO TESORO" },
    { ID: "TESOG", name: "TESS. ORDINE GIORNALISTI" },
    { ID: "PARLA", name: "TESS. PARLAMENTARI" },
    { ID: "MAGIS", name: "TESS. PERS. MAGISTRATI" },
    { ID: "GFTRI", name: "TESS. POL. TRIB. G.D.F." },
    { ID: "PSFEM", name: "TESS. POLIZIA FEMMINILE" },
    { ID: "TESPC", name: "TESS. PRES.ZA CONS. MIN." },
    { ID: "TESPI", name: "TESS. PUBBLICA ISTRUZIONE" },
    { ID: "DESIS", name: "TESS. S.I.S.D.E." },
    { ID: "ACSOT", name: "TESS. SOTT.LI AG.CUSTODIA" },
    { ID: "GFSOT", name: "TESS. SOTT.LI G.D.F." },
    { ID: "VISOT", name: "TESS. SOTT.LI VIG. URBANI" },
    { ID: "VVSOT", name: "TESS. SOTTUFF.LI VV.FF." },
    { ID: "AMSOT", name: "TESS. SOTTUFFICIALI A.M." },
    { ID: "CCSOT", name: "TESS. SOTTUFFICIALI CC" },
    { ID: "EISOT", name: "TESS. SOTTUFFICIALI E.I." },
    { ID: "SDSOT", name: "TESS. SOTTUFFICIALI SISMI" },
    { ID: "CFSOT", name: "TESS. SOTTUFICIALI C.F.S." },
    { ID: "MMSOT", name: "TESS. SOTTUFICIALI M.M." },
    { ID: "PPSOV", name: "TESS. SOVRINTENDENTI P.P." },
    { ID: "PSSOT", name: "TESS. SOVRINTENDENTI P.S." },
    { ID: "ACUFF", name: "TESS. UFF.LI AG.CUSTODIA" },
    { ID: "VIUFF", name: "TESS. UFF.LI VIG.URBANI" },
    { ID: "CCUFF", name: "TESS. UFFICIALE" },
    { ID: "AMUFF", name: "TESS. UFFICIALI A.M." },
    { ID: "CFUFF", name: "TESS. UFFICIALI C.F.S." },
    { ID: "EIUFF", name: "TESS. UFFICIALI E.I." },
    { ID: "GFUFF", name: "TESS. UFFICIALI G.D.F." },
    { ID: "MMUFF", name: "TESS. UFFICIALI M.M." },
    { ID: "PPUFF", name: "TESS. UFFICIALI P.P." },
    { ID: "PSUFF", name: "TESS. UFFICIALI P.S." },
    { ID: "SDUFF", name: "TESS. UFFICIALI SISMI" },
    { ID: "VVUFF", name: "TESS. UFFICIALI VV.FF." },
    { ID: "TESIN", name: "TESS.ISCR. ALBO INGEGNERI" },
    { ID: "TESAR", name: "TESS.ISCR.ALBO ARCHITETTI" },
    { ID: "TEPOL", name: "TESS.MIN.POLIT.AGRIC.FOR." },
    { ID: "TESNO", name: "TESSERA DELL'ORDINE NOTAI" },
    { ID: "TESAV", name: "TESSERA ISCR. ALBO AVVOC." },
    { ID: "TESDI", name: "TESSERA RICONOSC. D.I.A." },
    { ID: "TESUN", name: "TESSERA U.N.U.C.I." },
    { ID: "RIFUG", name: "TITOLO VIAGGIO RIF.POLIT." },
  ],

  // Italy Country Code
  Italy_Country_Code: "100000100",

  whatsAppMSGS: [
    {
      ID: 1,
      name: "welcome message",
      msg: "Welcome to Cinnamon Lakehouse!🤗  \n \n Dear Guest, 🤗 \n \n Hello! I'm Fernanda from Cinnamon Lakehouse. 😍 \n \n Your arrival is very close, and we're so excited to welcome you to our villa 🏡! Get ready for an unforgettable vacation. 🥰\n To make your check-in as smooth and welcoming as possible, please let us know your expected arrival time. The villa will be available for check-in from 3:00 PM to midnight. A specific time will help us organize our best ways to welcome you! \n To expedite the registration process, please remember to send us your identity documents (for all guests) by email; [EMAIL_ADDRESS]",
    },
    {
      ID: 2,
      name: "near by location",
      msg: "Hi 👋 \n \n I hope you're having a lot of fun! \n \n To make your stay even more memorable, I wanted to share some ideas to explore this beautiful area. \n \n There's so much to see and do right around the villa 🏡 \n \n Must-see attractions and local gems😍 \n \n If you are looking for an unforgettable experience, I highly recommend Gardaland Park, one of the most famous amusement parks in Italy! It's only a short drive away and offers fun for everyone. [https://maps.app.goo.gl/npdEGBqqN4HipfUK9? G_st=ic] 🎢 \n \n For a touch of history and breathtaking views, don't miss the splendid Scaligero Castle in Sirmione. It's a really picturesque place right on Lake Garda. [https://maps.app.goo.gl/tmXaY2QAhY12mH396? G_st=ic] 🏰 \n \n You could also enjoy visiting the Castle of Lazise, a beautiful mediaeval fortress right on the shores of Lake Garda, perfect for a historical walk. [https://maps.app.goo.gl/wkK2DBzb3WaXg7Hi8? G_st=ic] 🛡️ \n \n If you are interested in exploring a fascinating local village, I recommend a visit to Borghetto sul Mincio. It is known for its ancient water mills and romantic atmosphere, perfect for a pleasant walk. [https://maps.app.goo.gl/u36UWHBRZNSLg3WV6? G_st=ic] 🌳 \n \n Don't forget the Viva Nature Park in Bussolengo, a fantastic wildlife park and zoo that offers an immersive experience with animals from all over the world! Quercia location, 37012 Bussolengo VR. 🦒🦓🦁 \n https://maps.app.goo.gl/nTyTe6ZMfN4waqj77?g_st=ipc",
    },
    {
      ID: 3,
      name: "Tips for catering",
      msg: "Tips for catering 🍕 🍽️🍸 \n \n The area around Cavalcaselle is fantastic for foodies, offering a great mix of traditional Italian and diverse cuisines! Authentic Italian flavours: For a delicious and authentic meal, I suggest Trattoria AL TAOLON. It is known for its fresh, regional dishes and cosy atmosphere. [https://maps.app.goo.gl/zWBPJ8BL5YfNM2st7? G_st=ic] 🇮🇹🧑‍🍳 You will also find excellent Italian cuisine and pizza at Ristorante Pizzeria Gunè. It's one of the local favourites! [https://maps.app.goo.gl/2B2Ensh8MgnxaRYHA? G_st=ic] 🍕 For another fantastic Italian meal, take a look at Tavernetta Ristorante Pizzeria & Albergo. They offer traditional dishes in a cosy environment. [https://maps.app.goo.gl/J5tPHMwS25LUcdSA8? G_st=ic] 🍝 Bella Vista | Restaurant Pizzeria [https://maps.app.goo.gl/PQpTN8u36tsU7HRU7? G_st=ipc] The Plume [https://maps.app.goo.gl/NaSaLepE2E8QTRgD8? G_st=ipc]  Hosteria La Corte [https://maps.app.goo.gl/eHpoA2wHeNptHoQw7? G_st=ipc] Restaurant Pizzeria La Cascina, https://maps.app.goo.gl/bukfZHRbp1A2ztmQA?g_st=ipc Other culinary delights: If you fancy something different, Better Sushi Castelnuovo offers a great selection of Japanese cuisine, and it's an all-you-can-eat restaurant! [https://maps.app.goo.gl/h6pJGuNPipccvMUL6? G_st=ic] 🍣 Relax and explore The countryside here is ideal for relaxing walks and enjoying the beautiful scenery. Take your time, immerse yourself in the atmosphere and discover the hidden gems around CINNAMON LAKEHOUSE If you want to play bowling 🎳 with your family, I recommend the bowling centre on the third floor of: Grand Canyon Bowling Billiards The Big Apple Shoppingland, https://maps.app.goo.gl/hoNaJGv9FdCY5MCu6?g_st=ipc It's open until one in the morning and it's a great place for kids! I hope these suggestions help you have even more fun! ❤️ Enjoy your stay!",
    },
    {
      ID: 4,
      name: "Grocery Shopping & Essentials",
      msg: "Grocery Shopping & Essentials 🛒🍎 \n \n The area around Via San Zeno is well-equipped with everything you might need during your stay. Here are the best spots for your grocery shopping: \n Supermarkets & Quick Bites \n \n Lidl is a great choice for a wide variety of products at excellent prices. It is very convenient for a full pantry restock.\n Features a fresh bakery section with daily bread and pastries.  \n Large parking area and wide selection of international and local items.\n Famila Superstore is a very large and well-organized supermarket where you can find high-quality fresh produce, meat, and cheese.\n Offers a great 'gastronomia' counter with ready-to-eat Italian dishes.\n  Extensive selection of local wines and Italian specialty brands. \n Supermercato Orvea is another excellent option nearby, known for its clean environment and premium product selection.\n Includes a well-stocked butcher and deli department.\n Conveniently located next to other shops and services. \n McDonald's Peschiera del Garda is just a 5-minute drive away if you are looking for a quick, familiar meal or a late-night snack.\n Equipped with a McDrive for quick pickup.\n Features a McCafé for breakfast and coffee.\n \n Local Bakery & Small Shops \n For your daily fresh bread or a quick morning pastry, you can also find small local shops and a bakery within walking distance in the heart of Cavalcaselle. Parking at the Villa 🚗 \n\n Regarding your arrival, you can easily park your car right in front of the villa, along the street. It is safe and very convenient for unloading your luggage.\n\n I hope these tips help you settle in perfectly! Enjoy your shopping and your stay at Cinnamon Lakehouse! ❤️",
    },
    {
      ID: 5,
      name: "Wi-Fi",
      msg: "https://drive.google.com/file/d/1MmAD-4oMFsIUmp88DhMPiTv-k6YYuuc-/view?usp=sharing",
    },
    {
      ID: 6,
      name: "Security Code",
      msg: "https://drive.google.com/file/d/18XQNeAeE1F3zrNm2AwEjx26sB0BGDBvH/view?usp=sharing",
    },
  ],
};
